export const getBackendUrl = () => {
  // UNCOMMENT the line below when you want to use the local backend
  // return 'https://localhost:7189';

  return 'https://api.shivajirajan.com';
};

export const BACKEND_URL = getBackendUrl();


